// Allowed file list

export const ALLOWED_FILE_TYPES = [
  // Documents
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'txt',
  'csv',
  'tsv',
  'json',
  'xml',
  'numbers',
  'pages',
  // Images
  'jpg',
  'jpeg',
  'png',
  'gif',
  'bmp',
  'tiff',
  'ico',
  'webp',
  // Videos
  'mp4',
  'mov',
  // Archives
  'zip',
  'rar',
  '7z',
  'tar',
  'gz',
  // Medical Images and documents https://chatgpt.com/share/6870937f-eca4-8001-8b00-7aafe2ca57b5
  'dcm',
  'nii',
  'nii.gz',
  'hdr',
  'img',
  'ima',
  'mnc',
  'hl7',
  'edi',
  'edf',
  'scp',
  'dat',
  'hea',
  'atr',
  'fasta',
  'fa',
  'fastq',
  'fq',
  'vcf',
  'bam',
  'cram',
  'rtf',
  'x12',
  'edi',
  'astm',
  'gdt',
];

export const KENSHIN_ALLOWED_FILE_TYPES = ['zip', 'rar', '7z'];
